{
  "actionbar.actions": "Acties",
  "actionbar.actionsAvailable": "Acties beschikbaar.",
  "actionbar.clearSelection": "Selectie wissen",
  "actionbar.selected": "{count, plural, =0 {Niets geselecteerd} other {# geselecteerd}}",
  "actionbar.selectedAll": "Alles geselecteerd",
  "breadcrumbs.more": "Meer items",
  "button.pending": "in behandeling",
  "calendar.invalidSelection": "Geselecteerde {selectedCount, plural, one {datum} other {datums}} niet beschikbaar.",
  "combobox.noResults": "Geen resultaten",
  "contextualhelp.help": "Help",
  "contextualhelp.info": "Informatie",
  "datepicker.endTime": "Eindtijd",
  "datepicker.startTime": "Starttijd",
  "datepicker.time": "Tijd",
  "dialog.alert": "Melding",
  "dialog.dismiss": "Negeren",
  "dropzone.replaceMessage": "Bestand neerzetten om te vervangen",
  "inlinealert.informative": "Informatie",
  "inlinealert.negative": "Fout",
  "inlinealert.notice": "Waarschuwing",
  "inlinealert.positive": "Geslaagd",
  "label.(optional)": "(optioneel)",
  "label.(required)": "(vereist)",
  "menu.moreActions": "Meer handelingen",
  "notificationbadge.indicatorOnly": "Nieuwe activiteit",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Selecteren…",
  "slider.maximum": "Maximum",
  "slider.minimum": "Minimum",
  "table.loading": "Laden...",
  "table.loadingMore": "Meer laden...",
  "table.resizeColumn": "Kolomgrootte wijzigen",
  "table.sortAscending": "Oplopend sorteren",
  "table.sortDescending": "Aflopend sorteren",
  "tag.actions": "Acties",
  "tag.hideButtonLabel": "Minder weergeven",
  "tag.noTags": "Geen",
  "tag.showAllButtonLabel": "Alles tonen ({tagCount, number})",
  "toast.clearAll": "Alles wissen",
  "toast.collapse": "Samenvouwen",
  "toast.showAll": "Alles weergeven"
}
